import fwUtil from 'framework-util'

  export function gtoYuqing(){
    return custemRequest({
      url: 'toYuQingController/toSentiment',
      method: 'get'
    })
  }


// WEBPACK FOOTER //
// ./src/api/pubsentiment/toYuqing.js